var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _vm.isOrg
            ? _c(
                "v-flex",
                {
                  staticClass: "headline",
                  attrs: { xs6: "", md3: "", lg2: "" }
                },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.warehouses,
                      label: _vm.$t("selectVendor"),
                      "item-text": "warehouseName",
                      "return-object": ""
                    },
                    on: { change: _vm.changeWarehouse },
                    model: {
                      value: _vm.currentWarehouse,
                      callback: function($$v) {
                        _vm.currentWarehouse = $$v
                      },
                      expression: "currentWarehouse"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isOrg
            ? _c(
                "v-flex",
                { attrs: { xs3: "", lg1: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addNewSupport()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("add")]),
                      _vm._v(" " + _vm._s(_vm.$t("case")) + "\n      ")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _c("span", { staticClass: "tabItem" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t(tabItem.toLowerCase())) +
                    "\n      "
                )
              ])
            ])
          }),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c(
                "v-tab-item",
                { key: "active" },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        row: "",
                        wrap: "",
                        "justify-end": "",
                        "align-baseline": ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "success--text caption" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "align-end": "" } },
                            [
                              _c("v-flex", { attrs: { md2: "" } }, [
                                _c(
                                  "span",
                                  { staticClass: "realtime-border px-1" },
                                  [_vm._v(_vm._s(_vm.$t("realTIME")))]
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.isOrg
                                ? _c(
                                    "v-flex",
                                    { attrs: { md3: "" } },
                                    [
                                      _c("v-select", {
                                        staticStyle: {
                                          "margin-top": "0",
                                          "padding-top": "0",
                                          height: "20px"
                                        },
                                        attrs: {
                                          items: _vm.activeTagsList,
                                          "item-text": "displayName",
                                          "item-value": "key",
                                          label: _vm.$t("tag"),
                                          height: "24px",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.targetTag,
                                          callback: function($$v) {
                                            _vm.targetTag = $$v
                                          },
                                          expression: "targetTag"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        transform: "translateY(10px)"
                                      },
                                      attrs: { dark: "", color: "primary" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.exportActiveSupports.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("export")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-select", {
                                    staticStyle: {
                                      "margin-top": "0",
                                      "padding-top": "0",
                                      height: "20px",
                                      "padding-right": "10px"
                                    },
                                    attrs: {
                                      items: _vm.categories,
                                      "item-text": "displayName",
                                      "item-value": "value",
                                      label: _vm.$t("category"),
                                      height: "24px",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.category,
                                      callback: function($$v) {
                                        _vm.category = $$v
                                      },
                                      expression: "category"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-select", {
                                    staticStyle: {
                                      "margin-top": "0",
                                      "padding-top": "0",
                                      height: "20px"
                                    },
                                    attrs: {
                                      items: _vm.statuses,
                                      "item-text": "displayName",
                                      "item-value": "value",
                                      label: _vm.$t("status"),
                                      height: "24px",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.status,
                                      callback: function($$v) {
                                        _vm.status = $$v
                                      },
                                      expression: "status"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              name: "rtSearch",
                              "append-icon": "filter_list",
                              label: _vm.$t("search"),
                              "single-line": "",
                              "hide-details": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.supportSearch,
                              callback: function($$v) {
                                _vm.supportSearch = $$v
                              },
                              expression: "supportSearch"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabs[_vm.tab] === "Active"
                    ? _c("v-data-table", {
                        staticClass: "elevation-2 myDense",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.activeSupports,
                          search: _vm.supportSearch,
                          "rows-per-page-items": _vm.rowPerPage
                        },
                        on: {
                          "update:items": function($event) {
                            _vm.activeSupports = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.caseNumber))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { column: "" } },
                                        [
                                          _c("v-flex", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("submitter")) +
                                                ":\n                  "
                                            ),
                                            _vm.activeWarehouse
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.getOrgId(
                                                          props.item.tenantKey
                                                        ) +
                                                          " (" +
                                                          props.item
                                                            .tenantName +
                                                          ")"
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isOrg
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.warehouseName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isAdmin
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.tenantName ||
                                                          props.item
                                                            .warehouseName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _vm.activeWarehouse || _vm.isAdmin
                                            ? _c("v-flex", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(_vm.$t("agent")) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.agentDisplay(
                                                        props.item
                                                      ) || "---"
                                                    ) +
                                                    "\n                "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isOrg
                                            ? _c(
                                                "v-flex",
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(_vm.$t("tag")) +
                                                      ":\n                  "
                                                  ),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-start": "",
                                                        "align-center": ""
                                                      }
                                                    },
                                                    [
                                                      props.item.supportTags
                                                        .length
                                                        ? _c(
                                                            "v-flex",
                                                            _vm._l(
                                                              props.item
                                                                .supportTags,
                                                              function(tag) {
                                                                return _c(
                                                                  "v-chip",
                                                                  { key: tag },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        tag
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { md2: "" } },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showEditTagsPopup(
                                                                    props.item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("edit")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.showStatus(props.item.status))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          _vm.capitalize(props.item.category)
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          class: _vm.questionClass,
                                          attrs: { row: "", wrap: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { "my-2": "", xs12: "" } },
                                            [
                                              _c("b", { staticClass: "mr-2" }, [
                                                _vm._v(
                                                  _vm._s(_vm.$t("title")) + ":"
                                                )
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(props.item.title) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.hasTracking(props.item)
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    "my-2": "",
                                                    xs12: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Tracking#")
                                                        ) + ":"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatTracking(
                                                          props.item
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (props.item.comments || []).length
                                            ? _c(
                                                "v-flex",
                                                {
                                                  staticClass: "text-truncate",
                                                  attrs: {
                                                    "mb-2": "",
                                                    xs12: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            props.item.comments[
                                                              props.item
                                                                .comments
                                                                .length - 1
                                                            ].name
                                                          ) +
                                                          "\n                    [" +
                                                          _vm._s(
                                                            _vm.toDateMMDDHHmm(
                                                              props.item
                                                                .comments[
                                                                props.item
                                                                  .comments
                                                                  .length - 1
                                                              ].createTime
                                                            )
                                                          ) +
                                                          "]:\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.lastCommentPreview(
                                                          props.item
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.toTimestampString(
                                          props.item.createTime
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { attrs: { "text-xs-center": "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass:
                                            "bagdeRightTopClass btnWithoutPaddingMargin",
                                          attrs: { row: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    dark: "",
                                                    color: "primary",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showCommentsDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-badge", {
                                                    attrs: {
                                                      value: _vm.checkNewComment(
                                                        props.item
                                                      ),
                                                      color: "red",
                                                      overlap: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "badge",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "badge"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "new"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                        small:
                                                                          ""
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "comment"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(_vm.$t("open"))
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.activeWarehouse || _vm.isAdmin
                                            ? _c(
                                                "v-flex",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        dark:
                                                                          "",
                                                                        color:
                                                                          "primary",
                                                                        flat:
                                                                          "",
                                                                        medium:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.showInternalCommentsDialog(
                                                                            props.item
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-badge",
                                                                      {
                                                                        attrs: {
                                                                          value: _vm.checkNewInternalComment(
                                                                            props.item
                                                                          ),
                                                                          color:
                                                                            "red",
                                                                          overlap:
                                                                            ""
                                                                        },
                                                                        scopedSlots: _vm._u(
                                                                          [
                                                                            {
                                                                              key:
                                                                                "badge",
                                                                              fn: function() {
                                                                                return [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "badge"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "new"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              },
                                                                              proxy: true
                                                                            }
                                                                          ],
                                                                          null,
                                                                          true
                                                                        )
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-tooltip",
                                                                      {
                                                                        attrs: {
                                                                          top:
                                                                            ""
                                                                        },
                                                                        scopedSlots: _vm._u(
                                                                          [
                                                                            {
                                                                              key:
                                                                                "activator",
                                                                              fn: function(
                                                                                ref
                                                                              ) {
                                                                                var on =
                                                                                  ref.on
                                                                                return [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    _vm._g(
                                                                                      {
                                                                                        attrs: {
                                                                                          color:
                                                                                            "primary",
                                                                                          small:
                                                                                            ""
                                                                                        }
                                                                                      },
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _vm._v(
                                                                                        "checklist"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              }
                                                                            }
                                                                          ],
                                                                          null,
                                                                          true
                                                                        )
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "internal"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "white-space":
                                                              "pre-wrap",
                                                            "word-break":
                                                              "break-word",
                                                            "max-width": "300px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.item
                                                                .internalComments &&
                                                                props.item
                                                                  .internalComments
                                                                  .length
                                                                ? props.item
                                                                    .internalComments[
                                                                    props.item
                                                                      .internalComments
                                                                      .length -
                                                                      1
                                                                  ].name +
                                                                    ": " +
                                                                    props.item
                                                                      .internalComments[
                                                                      props.item
                                                                        .internalComments
                                                                        .length -
                                                                        1
                                                                    ].content +
                                                                    (props.item
                                                                      .internalComments[
                                                                      props.item
                                                                        .internalComments
                                                                        .length -
                                                                        1
                                                                    ].file
                                                                      ? " [attachment]"
                                                                      : "")
                                                                : "-- " +
                                                                    _vm.$t(
                                                                      "noLastMessage"
                                                                    ) +
                                                                    " --"
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1681017479
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { key: "history" },
                [
                  _vm.tabs[_vm.tab] === "History"
                    ? _c("PaginationController", {
                        attrs: {
                          refresh: _vm.paginationRefreshTrigger,
                          getDataActionName: "getDoneSupports",
                          historyLimit: _vm.historyLimit,
                          haveSearchBox: !!_vm.activeWarehouse || _vm.isAdmin,
                          searchBoxLabel: _vm.$t("orgName/orgId/title/tags"),
                          select: _vm.currentWarehouse.warehouseKey,
                          actionPredicates: _vm.actionPredicates,
                          keepKeywordCase: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "beforeMenu",
                              fn: function() {
                                return [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            "ml-2": "",
                                            "text-xs-left": ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "closedCasesWillBeRemovedAfterOneYear"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "beforeDate",
                              fn: function() {
                                return [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md24: "" } },
                                        [
                                          _c("v-select", {
                                            staticStyle: {
                                              "margin-top": "0",
                                              "padding-top": "0",
                                              height: "20px",
                                              "padding-right": "10px"
                                            },
                                            attrs: {
                                              items: _vm.categories,
                                              "item-text": "displayName",
                                              "item-value": "value",
                                              label: _vm.$t("category"),
                                              height: "24px",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.historyCategory,
                                              callback: function($$v) {
                                                _vm.historyCategory = $$v
                                              },
                                              expression: "historyCategory"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "afterDate",
                              fn: function() {
                                return [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "rtSearch",
                                        attrs: {
                                          name: "rtSearch",
                                          "append-icon": "filter_list",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.supportSearchHistory,
                                          callback: function($$v) {
                                            _vm.supportSearchHistory = $$v
                                          },
                                          expression: "supportSearchHistory"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "dataTable",
                              fn: function() {
                                return [
                                  _c("v-data-table", {
                                    attrs: {
                                      headers: _vm.closedHeaders,
                                      items: _vm.historySupports,
                                      "hide-actions": "",
                                      search: _vm.supportSearchHistory
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(props.item.caseNumber)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { column: "" } },
                                                    [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "submitter"
                                                              )
                                                            ) +
                                                            ":\n                      "
                                                        ),
                                                        _vm.activeWarehouse
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.getOrgId(
                                                                      props.item
                                                                        .tenantKey
                                                                    ) +
                                                                      " (" +
                                                                      props.item
                                                                        .tenantName +
                                                                      ")"
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isOrg
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    props.item
                                                                      .warehouseName
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isAdmin
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    props.item
                                                                      .tenantName ||
                                                                      props.item
                                                                        .warehouseName
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.activeWarehouse ||
                                                      _vm.isAdmin
                                                        ? _c("v-flex", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "agent"
                                                                  )
                                                                ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm.agentDisplay(
                                                                    props.item
                                                                  ) || "---"
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.isOrg
                                                        ? _c(
                                                            "v-flex",
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "tag"
                                                                    )
                                                                  ) +
                                                                  ":\n                      "
                                                              ),
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    "justify-start":
                                                                      "",
                                                                    "align-center":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  (
                                                                    props.item
                                                                      .supportTags ||
                                                                    []
                                                                  ).length
                                                                    ? _c(
                                                                        "v-flex",
                                                                        _vm._l(
                                                                          props
                                                                            .item
                                                                            .supportTags,
                                                                          function(
                                                                            tag
                                                                          ) {
                                                                            return _c(
                                                                              "v-chip",
                                                                              {
                                                                                key: tag
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    tag
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.capitalize(
                                                        props.item.category
                                                      )
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { class: _vm.questionClass },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            "my-2": "",
                                                            xs12: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "mr-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "title"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            _vm._s(
                                                              props.item.title
                                                            ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _vm.hasTracking(
                                                        props.item
                                                      )
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                "my-2": "",
                                                                xs12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "mr-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "tracking#"
                                                                      )
                                                                    ) + ":"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.formatTracking(
                                                                      props.item
                                                                    )
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  (_vm.activeWarehouse ||
                                                    _vm.isAdmin) &&
                                                  props.item.keywordDisplay
                                                    ? _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                "my-2": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "mr-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "keywords"
                                                                      )
                                                                    ) + ":"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .keywordDisplay
                                                                ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.activeWarehouse || _vm.isAdmin
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                props.item
                                                                  .resolveTypes &&
                                                                  props.item.resolveTypes.join(
                                                                    ", "
                                                                  )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      !!props.item.amount
                                                        ? _c(
                                                            "v-layout",
                                                            {
                                                              attrs: {
                                                                row: "",
                                                                wrap: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    "$" +
                                                                      props.item
                                                                        .amount
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.toTimestampString(
                                                      props.item
                                                        .lastModifiedTime
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    "text-xs-center": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "bagdeRightTopClass btnWithoutPaddingMargin",
                                                      attrs: { row: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                color:
                                                                  "primary",
                                                                flat: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.showCommentsDialog(
                                                                    props.item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    top: ""
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              _vm._g(
                                                                                {
                                                                                  attrs: {
                                                                                    color:
                                                                                      "primary",
                                                                                    small:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  "comment"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "open"
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.activeWarehouse ||
                                                      _vm.isAdmin
                                                        ? _c(
                                                            "v-flex",
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    top: ""
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "v-btn",
                                                                              _vm._g(
                                                                                {
                                                                                  attrs: {
                                                                                    dark:
                                                                                      "",
                                                                                    color:
                                                                                      "primary",
                                                                                    flat:
                                                                                      ""
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      $event.stopPropagation()
                                                                                      return _vm.showInternalCommentsDialog(
                                                                                        props.item
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _c(
                                                                                  "v-tooltip",
                                                                                  {
                                                                                    attrs: {
                                                                                      top:
                                                                                        ""
                                                                                    },
                                                                                    scopedSlots: _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key:
                                                                                            "activator",
                                                                                          fn: function(
                                                                                            ref
                                                                                          ) {
                                                                                            var on =
                                                                                              ref.on
                                                                                            return [
                                                                                              _c(
                                                                                                "v-icon",
                                                                                                _vm._g(
                                                                                                  {
                                                                                                    attrs: {
                                                                                                      color:
                                                                                                        "primary",
                                                                                                      small:
                                                                                                        ""
                                                                                                    }
                                                                                                  },
                                                                                                  on
                                                                                                ),
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "checklist"
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          }
                                                                                        }
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    )
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "internal"
                                                                                            )
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle: {
                                                                        "white-space":
                                                                          "pre-wrap",
                                                                        "word-break":
                                                                          "break-word",
                                                                        "max-width":
                                                                          "300px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .internalComments &&
                                                                            props
                                                                              .item
                                                                              .internalComments
                                                                              .length
                                                                            ? props
                                                                                .item
                                                                                .internalComments[
                                                                                props
                                                                                  .item
                                                                                  .internalComments
                                                                                  .length -
                                                                                  1
                                                                              ]
                                                                                .name +
                                                                                ": " +
                                                                                props
                                                                                  .item
                                                                                  .internalComments[
                                                                                  props
                                                                                    .item
                                                                                    .internalComments
                                                                                    .length -
                                                                                    1
                                                                                ]
                                                                                  .content +
                                                                                (props
                                                                                  .item
                                                                                  .internalComments[
                                                                                  props
                                                                                    .item
                                                                                    .internalComments
                                                                                    .length -
                                                                                    1
                                                                                ]
                                                                                  .file
                                                                                  ? " [attachment]"
                                                                                  : "")
                                                                            : "-- " +
                                                                                _vm.$t(
                                                                                  "noLastMessage"
                                                                                ) +
                                                                                " --"
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2651685984
                                    )
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          872802568
                        ),
                        model: {
                          value: _vm.doneSupports,
                          callback: function($$v) {
                            _vm.doneSupports = $$v
                          },
                          expression: "doneSupports"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.supportEditorToggle
        ? _c("SupportEdit", {
            attrs: {
              initWarehouse: _vm.currentWarehouse,
              support: _vm.supportInEdit
            },
            model: {
              value: _vm.supportEditorToggle,
              callback: function($$v) {
                _vm.supportEditorToggle = $$v
              },
              expression: "supportEditorToggle"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.commentsDialog
        ? _c("ChatRoom", {
            attrs: {
              title: _vm.$t("supportChatRoomTitle", {
                caseNumber: _vm.supportInEdit.caseNumber,
                status: _vm.showStatus(_vm.supportInEdit.status)
              }),
              maxTextQty: 1000,
              lastReadTime: _vm.supportLastRead,
              docPath: ["supports", _vm.supportKey],
              comments: _vm.supportComments,
              readOnly:
                _vm.supportInEdit && _vm.supportInEdit.status === "closed",
              nickName:
                _vm.activeWarehouse || _vm.isAdmin ? _vm.supportAgent : "",
              enableFileUpload: "",
              customSizeLimit: 10485760 * 2
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "issue",
                  fn: function() {
                    return [
                      _c(
                        "v-card",
                        { attrs: { hover: "", raised: "" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cardTitle",
                                  staticStyle: { "overflow-wrap": "break-word" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("createTime")) +
                                      ": " +
                                      _vm._s(
                                        _vm.toTimestampString(
                                          _vm.supportInEdit.createTime
                                        )
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.activeWarehouse
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "cardTitle",
                                      staticStyle: {
                                        "overflow-wrap": "break-word"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("organization")) +
                                          ": " +
                                          _vm._s(
                                            _vm.getOrgId(
                                              _vm.supportInEdit.tenantKey
                                            ) +
                                              " (" +
                                              _vm.supportInEdit.tenantName +
                                              ")"
                                          )
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "cardTitle",
                                      staticStyle: {
                                        "overflow-wrap": "break-word"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("warehouse")) +
                                          ": " +
                                          _vm._s(
                                            _vm.supportInEdit.warehouseName
                                          )
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", { staticClass: "cardTitle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.toTimestampString(
                                      _vm.supportInEdit.createTime
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.supportInEdit.address
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cardTitle",
                                        staticStyle: {
                                          "overflow-wrap": "break-word"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("address")))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cardText" }, [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(_vm.$t("sender")))]
                                      ),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.getLabelAddressInfo(
                                              _vm.supportInEdit.address,
                                              "sender"
                                            )
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cardText" }, [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(_vm.$t("recipient")))]
                                      ),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.getLabelAddressInfo(
                                              _vm.supportInEdit.address,
                                              "recipient"
                                            )
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br")
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cardTitle",
                                  staticStyle: { "overflow-wrap": "break-word" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("question")) +
                                      ": " +
                                      _vm._s(_vm.supportInEdit.title)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasTracking(_vm.supportInEdit)
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("tracking")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(
                                          _vm.formatTracking(_vm.supportInEdit)
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.upc
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Upc")]
                                    ),
                                    _vm._v(": " + _vm._s(_vm.supportInEdit.upc))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.labelId
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("LabelID")))]
                                    ),
                                    _vm._v(
                                      ": " + _vm._s(_vm.supportInEdit.labelId)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.quantity !== undefined &&
                              _vm.supportInEdit.quantity !== ""
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("qty")))]
                                    ),
                                    _vm._v(
                                      ": " + _vm._s(_vm.supportInEdit.quantity)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.shipmentId
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("shipmentID")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.shipmentId)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.pickUpDate
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("pickUpDate")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.pickUpDate)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.productDescription
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("productDescription"))
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(
                                          _vm.supportInEdit.productDescription
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.totalWeight
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("totalWeightUpperCase"))
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.totalWeight)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.productValue
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("productValue")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.productValue)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.totalValue
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("totalValue")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.totalValue)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.postageAmount
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("postageAmount")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.postageAmount)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.supportInEdit.length ||
                              _vm.supportInEdit.width ||
                              _vm.supportInEdit.height
                                ? _c("div", { staticClass: "cardText" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(_vm.$t("packageSize")))]
                                    ),
                                    _vm._v(
                                      ": " +
                                        _vm._s(_vm.supportInEdit.length || 0) +
                                        " x " +
                                        _vm._s(_vm.supportInEdit.width || 0) +
                                        " x " +
                                        _vm._s(_vm.supportInEdit.height || 0)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "cardText" }, [
                                _vm._v(_vm._s(_vm.supportInEdit.question))
                              ]),
                              _vm._v(" "),
                              (_vm.supportInEdit.attachments || []).length
                                ? _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    _vm._l(
                                      _vm.supportInEdit.attachments,
                                      function(file, index) {
                                        return _c("FsFileChip", {
                                          key: "file" + index,
                                          staticClass: "ma-2",
                                          attrs: {
                                            file: file,
                                            width: "100%",
                                            "aspect-ratio": "1.7"
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                (_vm.activeWarehouse || _vm.isAdmin) &&
                _vm.tab === 0 &&
                _vm.supportInEdit &&
                _vm.supportInEdit.status !== "closed"
                  ? {
                      key: "operation",
                      fn: function() {
                        return [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "no-wrap": "",
                                "align-baseline": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs4: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "chatroom-op mx-2",
                                    attrs: {
                                      label: _vm.$t("status"),
                                      items: _vm.supportStatus,
                                      "item-text": "displayName",
                                      "item-value": "value"
                                    },
                                    model: {
                                      value: _vm.supportInEditNewStatus,
                                      callback: function($$v) {
                                        _vm.supportInEditNewStatus = $$v
                                      },
                                      expression: "supportInEditNewStatus"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.supportInEditNewStatus === "in progress" ||
                              _vm.supportInEditNewStatus === "closed"
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "chatroom-op mx-2",
                                        attrs: {
                                          name: "agentName",
                                          label: _vm.$t("agentName"),
                                          value: _vm.supportAgent,
                                          readonly:
                                            _vm.supportInEditNewStatus ===
                                            "closed",
                                          clearable:
                                            _vm.supportInEditNewStatus !==
                                            "closed"
                                        },
                                        model: {
                                          value: _vm.agentName,
                                          callback: function($$v) {
                                            _vm.agentName = $$v
                                          },
                                          expression: "agentName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { small: "", color: "primary" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.updateSupportStatus()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("change")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _vm.supportInEdit.status !== "closed"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.showResolvePopup.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("resolve")))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            ),
            model: {
              value: _vm.commentsDialog,
              callback: function($$v) {
                _vm.commentsDialog = $$v
              },
              expression: "commentsDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.internalCommentsDialog
        ? _c("ChatRoom", {
            attrs: {
              title: _vm.$t("supportChatRoomInternalTitle", {
                caseNumber: _vm.supportInEdit.caseNumber,
                status: _vm.showStatus(_vm.supportInEdit.status)
              }),
              lastReadTime: _vm.internalCommentsLastRead,
              docPath: ["supports", _vm.supportKey],
              commentsField: "internalComments",
              comments: _vm.internalComments,
              readOnly:
                _vm.supportInEdit && _vm.supportInEdit.status === "closed",
              enableFileUpload: "",
              customSizeLimit: 10485760 * 2
            },
            model: {
              value: _vm.internalCommentsDialog,
              callback: function($$v) {
                _vm.internalCommentsDialog = $$v
              },
              expression: "internalCommentsDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resolveDialogFlag
        ? _c("SupportResolvePopup", {
            attrs: {
              supportKey: _vm.supportKey,
              defaultAmount: _vm.estimatedResolveAmount
            },
            on: { resolved: _vm.onSupportResolved },
            model: {
              value: _vm.resolveDialogFlag,
              callback: function($$v) {
                _vm.resolveDialogFlag = $$v
              },
              expression: "resolveDialogFlag"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowEditTagsPopup
        ? _c("SimpleTextPopup", {
            attrs: { rightMethod: _vm.saveTags },
            on: {
              popupClose: function() {
                return (this$1.isShowEditTagsPopup = false)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("v-combobox", {
                        attrs: {
                          items: _vm.activeTagsList,
                          "item-text": "displayName",
                          "item-value": "key",
                          label: _vm.$t("serviceType"),
                          "return-object": false,
                          chips: "",
                          multiple: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.currentItemTagKeys,
                          callback: function($$v) {
                            _vm.currentItemTagKeys = $$v
                          },
                          expression: "currentItemTagKeys"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2919649226
            ),
            model: {
              value: _vm.isShowEditTagsPopup,
              callback: function($$v) {
                _vm.isShowEditTagsPopup = $$v
              },
              expression: "isShowEditTagsPopup"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2785324f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2785324f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support.vue
// module id = null
// module chunks = 